/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/require-tagless-components */
import { action } from '@ember/object';
import Component from '@ember/component';

export default class AttendanceNote extends Component {
  notesOpen = false;
  onChange() {}

  @action
  toggle() {
    this.toggleProperty('notesOpen');
  }

  @action
  clear() {
    this.onChange();
  }
}
